/** ProductLicense replaces the current Subscription class specifically.
 *  There are two different types of licenses 100 = Trial 200 = Purchased
 *  count is what populates the LicensesCount field in the UI.
 */

import moment from 'moment'

export default class ProductLicense {
  public id: string = ''
  public productId: string = ''
  public licenseType: number = 0
  public serialNumber: string = ''
  public subscriptionStartDate: string = moment().format('YYYY-MM-DD')
  public subscriptionEndDate: string = moment()
    .add(1, 'year')
    .format('YYYY-MM-DD')
  public showStartDatePicker: boolean = false
  public showEndDatePicker: boolean = false
  public licenseCount: number = 1
  public updatedSerialNumber: string = ''
  public shouldUpdateSerialNumber: boolean = false
}
